<template>
  <el-menu-item style="float:right">
    <a :href="vosLink" target="_blank">
      <i class="el-icon-money text-white"></i> Recharge
    </a>
  </el-menu-item>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  mounted() {
    this.getResellerFields({id: this.userId}).then( (r) => {
      this.vosLink = r.data.vos_link
    })
  },
  methods: {
    ...mapActions('user-reseller-features-api', {
      prepareNewResellerFields: 'create',
      getResellerFields: 'get',
      updateResellerFields: 'update'
    }),
  },
  data () {
    return {
      userId: $store.state['user-state'].profile.id,
      vosLink: null
    }
  }
}
</script>
